<template>
  <div style="overflow-y: auto;">
        <b-overlay
        :show="show"
        spinner-variant="primary"
        spinner-large
        rounded="sm"
        style="height:100vh"
        variant="dark"
        id="loader"
      >
      <b-container fluid style="padding-top: 100px;text-align:left">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>Consumer Registration</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title">Consumer Registration</span>
          </b-col>
        </b-row>
        <hr/>
        <div style="padding-left:30px;  ">

          <b-row style="padding-top: 10px;">
                <b-col col cols="12" sm="3" md="3" lg="2" style="padding-top: 7px;">
                      <span style="font-weight:600" >Consumer No <span class="text-danger">*</span></span>
                </b-col>
                <b-col col cols="6" sm="3" md="6" lg="4">
                    <b-form-input type="text" maxlength="12" value="" id="consumerNumber" placeholder="Enter your Consumer Number" autocomplete="off" trim required />
                </b-col>
                <b-col col cols="4" sm="3" md="3" lg="1">
                      <b-button @click="showDetails()" block pill variant="primary" size="md" class="go" style="width:100%">
                      <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                   </b-button>
                </b-col>
              </b-row>
        <br>
      <!-- </form> -->
      <div id="alreadyRegistered" style="display:none" >
        <b-row>
          <b-col cols=10 offset-lg=2>
              <span style="color:#f2800e;font-weight:600" >
                Consumer number is already registered with mobile number :
                <span id="regMobile"  style="font-weight:700"></span> </span>
          </b-col>

          <b-col cols=10  offset-lg=2><br>
            <span>
              To update your mobile number please <a href="/website" style="color:#126aef;">Log In to Your Account </a> 
              <br>or download 
              <a target="_blank" style="color:#126aef;" href="https://www.apdcl.org/website/docs/acts_and_rules/mobile_update_form.pdf">
                <img src='https://www.apdcl.org/website/assets/pdf-icon-3.png' height="25px" width="25px"/>
                 Mobile Number Update form
              </a>
               and submit at subdivision : <strong> {{ esdName }} ESD</strong>
            </span> 
        </b-col>
        </b-row>
      </div>
      <div id="UserDetails" class="userDetails marginRight30px" >
        <b-row>
          <b-col cols=12>
              <span class="heading">User Details</span>
          </b-col>
        </b-row>
        <hr/>
        <br>
        <!-- <form id="userRegistration"> -->
          <b-row>
            <b-col col cols="5" sm="2" md="2" lg="2">
                <span class="label">Consumer Name : </span>
            </b-col>
            <b-col col cols="7" sm="4" md="4" lg="3">
              <span id="consName" ></span>
            </b-col>

         
          </b-row>
          <br>
          <b-row>
            <b-col col cols="5" sm="2" md="2" lg="2">
                Mobile No <span class="text-danger">*</span> :
            </b-col>
            <b-col col cols="7" sm="4" md="4" lg="3">
                <span id="mobNo"></span>
              </b-col>
            <b-col col cols="5" sm="2" md="2" lg="2" class="marginTop10px">
                Email ID </span> :
            </b-col>
            <b-col col cols="7" sm="4" md="4" lg="3" class="marginTop10px">
               <span id="email"></span>
               
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col col cols="12" sm="3" md="3" lg="3" offset-md="2" offset-lg="2">
                <b-button block squared variant="primary"  id="button"  @click="sendOtp()">
                  Register</b-button>
                 <br>
            </b-col>
          </b-row>
          
          <b-row>
            <b-col col cols="12" sm="12" md="12" lg="12">
              <span style="color:#ef4d12;"> 
             *** To update your mobile number  without registration download 
              <a target="_blank" style="color:#126aef;" href="https://www.apdcl.org/website/docs/acts_and_rules/mobile_update_form.pdf">
                <img src='https://www.apdcl.org/website/assets/pdf-icon-3.png' height="25px" width="25px"/>
                 Mobile Number Update form
              </a>
               and submit at subdivision : <strong> {{ esdName }} ESD</strong>
            </span>
            </b-col>
         </b-row>
        <!-- </form> -->
      </div>

      </div>
  </b-container>
  <br>
  

  <b-modal id="otpModal" centered no-close-on-esc  no-close-on-backdrop title="OTP Verification" hide-footer>
    <b-overlay
    :show="show1"
    spinner-variant="primary"
    spinner-large
    rounded="sm"
    style=""
    variant="dark"
    id="loader"
  >
    Enter the OTP received in your mobile number :
    <b-form-input type="number" id="otp" ></b-form-input><br>
    <b-button class="btn" variant="primary" id="success-btn" @click="registration()" >Verify</b-button> &nbsp&nbsp
    <b-button class="btn" variant="outline-primary" id="success-btn" @click="resendOtp()" >Resend OTP</b-button>
</b-overlay>
  </b-modal>

  <b-modal id="successModal" centered no-close-on-esc no-close-on-backdrop scrollable  hide-footer hide-header>
    <h3>Consumer Registration</h3>
    <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
      <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
      <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
    </svg>
    <p class="success">Successfully Registered !<br><br>
    <b-button class="btn btn-outline" variant="success" id="" @click="reloadPage()" >OK</b-button>
    </p>
  </b-modal>

  <b-modal id="failureModal" centered lazy scrollable title="Consumer Registration" hide-footer>
    <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
      <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
      <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
      <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
    </svg>
    <p class="error">Registration Failed ! </p>
    <p class="error" id="errorMsg">Consumer Already Registered </p>
  </b-modal>

  <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
    <span class="data" id="modalMsg">  </span>
    <br><br>
      <b-button  style="width:8rem" variant="outline-primary" @click="closeModal()">OK</b-button>
  </b-modal>
</b-overlay>
  </div>

</template>


<script>
import axios from 'axios';
import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'

var consNo= "";
export default {
  name: 'ConsReg',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' : HeaderMobile
    

  },
  computed: {

  },
  data() {
    return {
        value: '',
        show: false,
        show1: false,
        show2 : false,
        consNumber: "",
        selected: null,
        connType:"",
        esdName:""
    }
  },
  methods: {
    reloadPage()
    {
      window.location.reload();
    },
    

    showDetails() {
      consNo= document.getElementById("consumerNumber").value;
      this.consNumber=consNo;
      if(consNo=="")
        {

          this.$bvToast.toast('Enter 12 Digit Consumer Number !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
          document.getElementById("mobNo").focus();
         return;
        }
     
        let data = JSON.stringify({
        "consNo": consNo
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon+'/api/web/getRegConsumer',
        headers: {  
          'Content-Type': 'application/json'
        },
        data : data
      };
      var parent=this;
      parent.show=true;
      axios.request(config)
      .then((response) => {
        parent.show=false;
      //console.log(response.data);
      
        var data=response.data;
        var status = data.message;

        if(status=="00")
        {
          parent.esdName=response.data.subDivision;
          if(data.isRegistered=="not found")
          {
            document.getElementById("alreadyRegistered").style.display="none";
            document.getElementById("UserDetails").classList.add("showUserDetails");
            document.getElementById("consName").innerHTML = data.consName;
            document.getElementById("mobNo").innerHTML = data.mobileNo;
            document.getElementById("email").innerHTML = data.email;
            
          }

          else{
              
              document.getElementById("UserDetails").classList.remove("showUserDetails");
              document.getElementById("alreadyRegistered").style.display="block";
              document.getElementById("regMobile").innerHTML=data.mobileNo;

              }
        }
        else
        {
          parent.show= false;
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML="Sorry, Consumer Not Found";
          document.getElementById("UserDetails").classList.remove("showUserDetails");
        }

      })
      .catch((e) => {
      console.log("Caught", e);
      this.show= false;
    })

  },

sendOtp()
{
  
var parent =this;
  parent.show= true;
  axios.post(this.$urlArms+"/RestAPI/website/otpValidation?consNo="+consNo).then(function(response) {
  //  console.log(response.data);
    parent.show= false;
    if (response.data.msg == "success" && response.data.otpGenerated == "Y") {
      parent.$bvToast.toast('OTP Sent Successfully !', {
        title: `Success`,
        variant: 'success',
        solid: true
      });
      parent.$bvModal.show('otpModal');
    }
  });
},

closeModal(){
  this.$bvModal.hide('model')
},
resendOtp()
      {
        var parent =this;
        parent.show1= true;
        axios.post(this.$urlArms+"/RestAPI/website/resendOTP?consNo="+consNo).then(function(response) {
          parent.show1= false;
          if (response.data.msg == "success") {
            parent.$bvToast.toast('OTP Sent Successfully !', {
              title: `Success`,
              variant: 'success',
              solid: true
            });
          }
        else {
            parent.$bvToast.toast('OTP Could not Sent !', {
              title: `danger`,
              variant: 'danger',
              solid: true
            });
          }
        });
      },
  registration()  {
     
      var otp = document.getElementById("otp").value;
      var parent=this;

      if(otp=="")
        { 
          this.$bvToast.toast('Enter OTP !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
        return;
        }
        let data = JSON.stringify({
        "consNo": consNo,
        "otp":otp
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon+'/api/web/saveRegConsumer',
        headers: { 
          
          'Content-Type': 'application/json'
        },
        data : data
      };
      var parent=this;
      parent.show1=false;
      axios.request(config)
      .then((response) => {
        parent.show1=false;
        console.log(response.data);
  
          if(response.data.status=="success")
            {
               parent.$bvModal.hide('modalChangeNo');
               parent.$bvModal.show('successModal');
            }
                         
          else {
            
            parent.$bvModal.hide('modalChangeNo');
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML=response.data.message;
          }
        });
      },

    
  }
}
</script>

<style scoped="true">
.label{
}
.data{
  font-weight: 500;
  color: #e64a19      ;
  font-size: 1.1rem;
}
.userDetails
{
   visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
}
.showUserDetails
{
 visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}
.modalFont{
  width: 100px;
  display: block;
  margin: 40px auto 0;
}

.path {
  stroke-dasharray: 1000;
  stroke-dashoffset: 0;
}
.path.circle {
  -webkit-animation: dash 0.9s ease-in-out;
  animation: dash 0.9s ease-in-out;
}
.path.line {
  stroke-dashoffset: 1000;
  -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
  animation: dash 0.9s 0.35s ease-in-out forwards;
}
.path.check {
  stroke-dashoffset: -100;
  -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
  animation: dash-check 0.9s 0.35s ease-in-out forwards;
}

p {
  text-align: center;
  margin: 20px 0 60px;
  font-size: 1.25em;
}
p.success {
  color: #73AF55;
}
p.error {
  color: #D06079;
}
.hideDiv
{
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;

    padding: 0rem;
}
.showDiv
{
 visibility: visible;
 opacity: 1;
}
@-webkit-keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@-webkit-keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
@keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
  }
  @media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .marginRight30px{
      margin-right: 30px !important;
    }
  }
  @media (max-width: 576px) {
    .marginTop10px{
      margin-top: 10px !important;
    }
  }

</style>
